let AnalyticsMixin = {
    getPlanLabel: function(level, termCode) {
		var plan = '',
			term = '';

		level = parseInt(level, 10);
		termCode = parseInt(termCode, 10);

		switch (level) {
			case 0:
			case 1:
				plan = "Free";
				break;

			case 2:
				plan = "Pro (Legacy)";
				break;

			case 3:
				plan = "Ulitmate (Legacy)";
				break;

			case 4:
				plan = "Enterprise (Legacy)";
				break;

			case 5:
				plan = "VIP (Legacy)";
				break;

			case 6:
				plan = "Pro";
				break;

			case 7:
				plan = "Ultimate";
				break;

			case 8:
				plan = "Agency";
				break;
		}

		switch (termCode) {
			case 1:
				term = "Monthly";
				break;

			case 2:
				term = "Annual";
				break;

			case 3:
				term = "Quarterly";
				break;
		}

		return [plan, term].join(" - ");
	}
};

export default AnalyticsMixin;
